import React, { useEffect, useState } from 'react';
import { db, storage } from '../firebase';
import { collection, addDoc, getDocs, query, orderBy } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const imagesAssets = [
  '/assets/product1.jpg',
  '/assets/product2.jpg',
  '/assets/product3.jpg', // Add all your asset images here
];

const ProductImages = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch images from Firestore
  const fetchImages = async () => {
    try {
      const snapshot = await getDocs(query(collection(db, 'ProductImages'), orderBy('timestamp', 'asc')));
      const urls = snapshot.docs.map(doc => doc.data().url);
      setImages(urls);
    } catch (err) {
      console.error('Error fetching images:', err);
    } finally {
      setLoading(false);
    }
  };

  // Upload assets if Firestore collection is empty
  const uploadAssets = async () => {
    try {
      const snapshot = await getDocs(collection(db, 'ProductImages'));
      if (!snapshot.empty) return; // Already uploaded

      for (let i = 0; i < imagesAssets.length; i++) {
        const response = await fetch(imagesAssets[i]);
        const blob = await response.blob();

        const storageRef = ref(storage, `product_images/${Date.now()}_${i}.jpg`);
        await uploadBytes(storageRef, blob);

        const url = await getDownloadURL(storageRef);

        await addDoc(collection(db, 'ProductImages'), {
          url,
          timestamp: Date.now(), // for ordering
        });
      }
    } catch (err) {
      console.error('Upload error:', err);
    }
  };

  useEffect(() => {
    const init = async () => {
      await uploadAssets(); // Upload all assets if collection empty
      fetchImages();        // Fetch images from Firestore
    };
    init();
  }, []);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">All Product Images</h2>

      {loading ? (
        <p className="text-gray-500 text-lg">Loading...</p>
      ) : images.length === 0 ? (
        <p className="text-gray-500 text-lg">No images available.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {images.map((img, index) => (
            <div key={index} className="border rounded overflow-hidden">
              <img
                src={img}
                alt={`Product ${index + 1}`}
                className="w-full h-48 object-cover"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductImages;
